export default {
  pages: {
    faq: {
      title: 'Часто задаваемые вопросы(FAQ)',
      searchPlaceholder: 'Поиск',
    },
  },
};
